module.exports = {
  name: 'check-availability',
  listClass: 'default',
  defaultLimit: 100,
  columns: 2,
  itemIndexes: null
}